import api from './api/index'
import alert from './plugins/alert/alert'
import store from './store/index'
import imgLoader from './utils/imgLoader'
import myWx from './utils/wx'
import util from './utils/util'

export default {
  install (Vue) {
    alert.alertInit(Vue)
    // 添加组件
    // 添加过滤器
    // 全局报错处理
    // Vue.prototype.$throw = (error) => errorHandler(error, this)
    Vue.prototype.$http = api
    Vue.prototype.$store = store
    Vue.prototype.$alert = alert.alertMethods
    Vue.prototype.$imgLoader = imgLoader
    Vue.prototype.$myWx = myWx
    Vue.prototype.$util = util
    // 其他配置
  }
}
